var a=document.getElementsByTagName("a");
for (var i = 0; i < a.length; i++){
    if (a[i].target !== '_blank') {
        a[i].onclick=function()
        {   
            window.location=this.getAttribute("href");
            return false
        }
        
    }
}